import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import Input from '../ui/Input';
import usePersistedCollapse from '../../hooks/usePersistedCollapse';

const clampToInt = (value, min = 1) => Math.max(min, Math.floor(Number(value) || min));

export default function GridLayoutPanel({
  rows,
  columns,
  onRowsChange,
  onColumnsChange,
  showBoundaries,
  onShowBoundariesChange,
}) {
  const [collapsed, setCollapsed] = usePersistedCollapse('grid-layout');

  return (
    <div className="ss-print__panel">
      <div className="ss-print__panel-header">
        <h3 className="ss-print__panel-title">Grid</h3>
        <label className="ss-check ss-check--panel-header">
          <input type="checkbox" checked={showBoundaries} onChange={(e) => onShowBoundariesChange(e.target.checked)} />
          <span>Show Lines</span>
        </label>
        <button
          type="button"
          className="ss-print__lock-toggle"
          onClick={() => setCollapsed(!collapsed)}
          aria-expanded={!collapsed}
          aria-label={collapsed ? 'Expand grid layout panel' : 'Collapse grid layout panel'}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <ChevronRight size={16} aria-hidden="true" /> : <ChevronDown size={16} aria-hidden="true" />}
        </button>
      </div>

      {!collapsed && (
        <div className="ss-print__panel-row">
          <Input
            label="Columns"
            type="number"
            min={1}
            value={columns}
            onChange={(e) => onColumnsChange(clampToInt(e.target.value))}
          />
          <Input
            label="Rows"
            type="number"
            min={1}
            value={rows}
            onChange={(e) => onRowsChange(clampToInt(e.target.value))}
          />
        </div>
      )}
    </div>
  );
}
